<template lang="pug">
  div.edit-area
    slot

    vModal( v-model="show" :width="40" )
      template( v-slot:activator="{ on }" )
        button.edit-area__btn( @click="on" v-if="canIedit" ) Edit

      template( v-slot:header )
        |Редактирование

      input.edit-area__input(
        type="text"
        :value="text"
        @input="(e) => {$onInput(e, field)}"
        )

      template( v-slot:footer )
        vButton( xSmall @click="show = 0" ) Применить

</template>

<script>
import vModal from '../../modals/vModal'
import vButton from '../../elements/vButton'

export default {
  name: 'editable-block',
  props: {
    text: {
      type: String,
      default: null
    },
    field: {
      type: String,
      default: null
    },
    section: {
      type: String,
      default: null
    }
  },
  components: {
    vModal,
    vButton
  },
  data () {
    return {
      show: 1
    }
  }
}
</script>

<style lang="scss">
  .edit-area {
    position: relative;
    z-index: 9999;

    &__btn {
      position: absolute;
      top: 0;
      right: 0;
      transform: translateY(-85%);
      padding: .3rem .5rem;
      box-shadow: 0px 6px 17.3px 0.7px rgba(16, 22, 64, 0.15);

      cursor: pointer;

      border: .5px solid #ccc;
      border-radius: .1rem;

      background: white;

      transition: .2s ease all;

      &:active {
        transform: translateY(-80%);
        border: none;
      }

      &:focus {

        outline: none;
      }
    }

    &__input {
      padding: .7rem 1rem;
      min-width: 20rem;
    }
  }
</style>
